exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-gauge[data-v-6e897d24]{position:relative}", ""]);

// exports
